module.exports = __webpack_public_path__ + "img/long-icon.33a7f0c3.svg";